/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const meImpersonationOneClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const meImpersonationOneEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const meImpersonationOneExpiresAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const meImpersonationOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const meImpersonationOneStartedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const meMembershipsItemClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const meUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const meUserLastActiveAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)

export const Me = zod.object({
  impersonation: zod.union([
    zod.object({
      clinic: zod.object({
        id: zod.uuid().regex(meImpersonationOneClinicIdRegExp),
        name: zod.string(),
        slug: zod.string(),
        status: zod.enum(['active', 'inactive']),
      }),
      endedAt: zod.union([zod.iso.datetime({ offset: true }).regex(meImpersonationOneEndedAtOneRegExp), zod.null()]),
      expiresAt: zod.iso.datetime({ offset: true }).regex(meImpersonationOneExpiresAtRegExp),
      id: zod.uuid().regex(meImpersonationOneIdRegExp),
      startedAt: zod.iso.datetime({ offset: true }).regex(meImpersonationOneStartedAtRegExp),
    }),
    zod.null(),
  ]),
  memberships: zod.array(
    zod.object({
      clinic: zod.object({
        id: zod.uuid().regex(meMembershipsItemClinicIdRegExp),
        name: zod.string(),
        slug: zod.string(),
        status: zod.enum(['active', 'inactive']),
        timeZone: zod.string(),
      }),
      role: zod.enum(['admin', 'user']),
    }),
  ),
  mustChangePassword: zod.boolean(),
  platformRole: zod.union([zod.literal('super_admin'), zod.null()]),
  user: zod.object({
    email: zod.string(),
    id: zod.uuid().regex(meUserIdRegExp),
    lastActiveAt: zod.union([zod.iso.datetime({ offset: true }).regex(meUserLastActiveAtOneRegExp), zod.null()]),
    name: zod.string(),
  }),
})

export type Me = zod.input<typeof Me>
export type MeOutput = zod.output<typeof Me>
